module.exports = __webpack_public_path__ + "static/media/samp-id-card.7573faa6.png";